export function getError(err, message = "") {
  const errors = {
    UNIDENTIFIED_CUSTOMER: "Incorrect email address or password",
    TOKEN_INVALID: "The token is invalid",
    TAKEN: "This email or phone number is associated with another account",
    INVALID:
      "The phone number is invalid, please enter a correctly formatted mobile number including country code e.g +64212345678",
    PASSWORD_STARTS_OR_ENDS_WITH_WHITESPACE:
      "The password starts or ends with whitespace",
    NOT_FOUND: "The resource could not be found",
    INVALID_MULTIPASS_REQUEST: "The multipass token is invalid",
    CUSTOMER_DISABLED: `${message}`,
    DEFAULT: "An error occurred. Please try again later.",
  };
  return errors[err] || errors["DEFAULT"];
}
